import {Component, Injectable, OnInit, ViewChild} from '@angular/core';
import {defaultSpTokenResolver, PasswordResetRequest, Stormpath} from 'angular-stormpath';
import {Location} from '@angular/common';
import {Observable, ReplaySubject} from 'rxjs';
import {FormErrors} from '../../../components/forms/validation/form-validator.class';
import {NgForm} from '@angular/forms';
import {FormManager, FormSubmissionStatusCode} from '../../../components/forms/form-manager.class';

@Component({
    template: require('./reset-password-page.component.html'),
    styles: [require('./reset-password-page.component.scss')]
})
@Injectable()
export class ResetPasswordPageComponent implements OnInit {
    protected disabled: boolean;
    protected error: string;
    protected formModel: PasswordResetFormModel;
    protected posting: boolean;
    protected reset: boolean;
    protected verifying: boolean;
    protected verified: boolean;
    protected verificationFailed: boolean;
    protected sptoken: string;

    readonly form$ = new ReplaySubject<NgForm>(1);
    formErrors: FormErrors = {};
    private readonly _formManager: FormManager<any>;

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    constructor(public stormpath: Stormpath, public location: Location, fmgm: FormManager.InjectedMembers) {
        this._formManager = new FormManager(
            fmgm,
            this.form$,
            Observable.of(() => this.stormpath.resetPassword(this.formModel)),
            undefined,
            false
        );
    }

    ngOnInit() {
        this.verifying = false;
        this.verified = false;
        this.verificationFailed = false;
        this.formModel = {
            sptoken: this.spTokenResolver(),
            password: '',
            confirmPassword: ''
        };
        // debugger
        if (this.formModel.sptoken) {
            this.verify();
        }
        this._formManager.displayedErrors$.subscribe(errors => this.formErrors = errors);
    }

    spTokenResolver(): string {
        return defaultSpTokenResolver(this.location);
    }

    verify() {
        this.verifying = true;
        this.stormpath.verifyPasswordResetToken(this.formModel.sptoken)
            .subscribe(() => {
                this.verifying = false;
                this.verified = true;
            }, (error) => {
                this.verifying = false;
                if (error.status && error.status === 404) {
                    this.verificationFailed = true;
                } else {
                    this.error = error.message;
                }
            });
    }

    send() {
        this._formManager.save()
            .subscribe(result => {
                    if (result.status.code === FormSubmissionStatusCode.SUBMITTED) {
                        this.posting = false;
                        this.reset = true;
                    }
                },
                (error) => {
                    this.posting = false;
                    this.error = error.message;
                }
            );
    }

    onSubmit() {
        if (this.formModel.password !== this.formModel.confirmPassword) {
            this.error = 'Passwords do not match';
            return;
        }
        this.send();
    }
}

interface PasswordResetFormModel extends PasswordResetRequest {
    confirmPassword: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/login/reset-password/reset-password-page.component.ts